import React from 'react';

const AlertIcon = ({ width = 20, height = 20, fill = "#CF2222" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 116 116"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="57.8872" cy="57.8872" r="57.8872" fill={fill} />
    <path
      d="M57.8877 74.168C59.3268 74.1681 60.707 74.7402 61.7246 75.7578C62.7424 76.7756 63.3145 78.1564 63.3145 79.5957C63.3143 81.0349 62.7423 82.415 61.7246 83.4326C60.707 84.4503 59.3269 85.0223 57.8877 85.0225C56.4484 85.0225 55.0675 84.4504 54.0498 83.4326C53.0322 82.415 52.4601 81.0348 52.46 79.5957C52.46 78.1564 53.0321 76.7756 54.0498 75.7578C55.0675 74.7401 56.4484 74.168 57.8877 74.168Z"
      fill="white"
      stroke="white"
      strokeWidth="3.61795"
    />
    <path d="M57.8867 28.9434L57.8867 57.887" stroke="white" strokeWidth="14.4718" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default AlertIcon;